"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TICKET_TITLE_MAX_LENGTH = exports.TICKET_QUEUE_ERROR_CODES = exports.ticketQueueQuerySchema = exports.QUEUE_PRIORITY_FILTERS = exports.QUEUE_SEARCH_MAX_TERMS = exports.QUEUE_SEARCH_MAX_LENGTH = exports.QUEUE_PAGE_SIZE_MAX = exports.QUEUE_PAGE_SIZE_DEFAULT = exports.REPLY_RECEIVED_LABEL = exports.QUEUE_REPLY_FILTERS = exports.REPLY_RECEIVED = exports.NO_ASSIGNEE = exports.UNTRIAGED_PRIORITY = exports.QUEUE_SORT_DESCRIPTIONS = exports.QUEUE_SORT_LABELS = exports.QUEUE_SORTS = exports.ARCHIVE_VIEW_DESCRIPTIONS = exports.ARCHIVE_VIEW_LABELS = exports.QUEUE_VIEW_DESCRIPTIONS = exports.QUEUE_VIEW_LABELS = exports.TICKET_LIST_SCOPE_VIEWS = exports.TICKET_LIST_VIEWS = exports.ARCHIVE_VIEWS = exports.QUEUE_VIEWS = exports.TICKET_LIST_SCOPE_LABELS = exports.TICKET_LIST_SCOPE_STATES = exports.TICKET_LIST_SCOPES = void 0;
exports.otherTicketListScope = otherTicketListScope;
exports.isScopeView = isScopeView;
exports.ticketListViewLabel = ticketListViewLabel;
exports.ticketListViewDescription = ticketListViewDescription;
exports.searchTerms = searchTerms;
exports.threadMessageAnchor = threadMessageAnchor;
exports.threadEventAnchor = threadEventAnchor;
exports.threadEntryAnchor = threadEntryAnchor;
exports.ticketTitle = ticketTitle;
const zod_1 = require("zod");
const ticket_priority_js_1 = require("./ticket-priority.js");
const ticket_state_js_1 = require("./ticket-state.js");
/**
 * Coda dei ticket e dettaglio in sola lettura (PRD-004 US-1, story #2). Contratti fra l'API della
 * console (`GET /api/v1/tickets`, `GET /api/v1/tickets/:code`) e la web app: chiavi in inglese
 * come le altre API degli operatori, valori di dominio in italiano. Il prodotto non è né un filtro
 * né un campo: si legge solo nel prefisso del codice (DEC-003). Nessun canale paziente (DEC-005).
 */
/**
 * Ambiti della lista dei ticket (#123, decisione del product owner del 16/10/2026): la **coda** contiene
 * il lavoro da fare (Nuovo, In lavorazione, In attesa dell'utente), l'**archivio** i ticket Risolto,
 * Chiuso e Scartato. Stessa tabella, stessa ricerca e stessi filtri; viste diverse. Ogni ticket sta in
 * uno solo dei due: la riapertura di un Risolto lo riporta in coda (DEC-002 regola 5).
 */
exports.TICKET_LIST_SCOPES = ['coda', 'archivio'];
/** Gli stati di ciascun ambito: anche le opzioni del filtro «Stato» della pagina. */
exports.TICKET_LIST_SCOPE_STATES = {
    coda: ticket_state_js_1.OPEN_TICKET_STATES,
    archivio: ticket_state_js_1.ARCHIVED_TICKET_STATES,
};
/** Nome dell'ambito nei testi della console. */
exports.TICKET_LIST_SCOPE_LABELS = {
    coda: 'Coda',
    archivio: 'Archivio',
};
/** L'altro ambito: quello in cui la ricerca incrociata conta i risultati. */
function otherTicketListScope(scope) {
    return scope === 'coda' ? 'archivio' : 'coda';
}
/** Viste rapide della coda, nell'ordine in cui la coda le mostra. «Tutti» = tutti gli aperti. */
exports.QUEUE_VIEWS = [
    'tutti',
    'senza_priorita',
    'operatori',
    'pre_accesso',
    'allo_sviluppo',
    'da_rispondere',
];
/** Viste rapide dell'archivio (#123), nell'ordine in cui l'archivio le mostra. */
exports.ARCHIVE_VIEWS = ['tutti', 'risolti', 'chiusi', 'scartati'];
/** Tutte le viste, senza ripetere «Tutti»: i valori ammessi del parametro `view`. */
exports.TICKET_LIST_VIEWS = [...new Set([...exports.QUEUE_VIEWS, ...exports.ARCHIVE_VIEWS])];
/** Le viste di ciascun ambito, nell'ordine in cui la pagina le mostra. */
exports.TICKET_LIST_SCOPE_VIEWS = {
    coda: exports.QUEUE_VIEWS,
    archivio: exports.ARCHIVE_VIEWS,
};
/** Vero se la vista appartiene all'ambito. */
function isScopeView(scope, view) {
    return exports.TICKET_LIST_SCOPE_VIEWS[scope].includes(view);
}
exports.QUEUE_VIEW_LABELS = {
    tutti: 'Tutti',
    senza_priorita: 'Senza priorità',
    operatori: 'Operatori',
    pre_accesso: 'Pre-accesso',
    allo_sviluppo: 'Allo sviluppo',
    da_rispondere: 'Da rispondere',
};
/** Che cosa conta ciascuna vista della coda, per il tooltip e per chi legge il contratto. */
exports.QUEUE_VIEW_DESCRIPTIONS = {
    tutti: "Tutti i ticket aperti: Nuovo, In lavorazione, In attesa dell'utente",
    senza_priorita: 'Ticket aperti ancora da triare',
    operatori: 'Segnalazioni dal canale autenticato, in piattaforma',
    pre_accesso: 'Segnalazioni dal canale pre-accesso, recapiti non verificati',
    allo_sviluppo: 'Responsabile o collaboratore del gruppo Sviluppo',
    da_rispondere: "Ticket aperti in cui l'ultimo messaggio scambiato con chi ha segnalato è una sua risposta",
};
exports.ARCHIVE_VIEW_LABELS = {
    tutti: 'Tutti',
    risolti: 'Risolti',
    chiusi: 'Chiusi',
    scartati: 'Scartati',
};
/** Che cosa conta ciascuna vista dell'archivio. */
exports.ARCHIVE_VIEW_DESCRIPTIONS = {
    tutti: 'Tutti i ticket archiviati: Risolto, Chiuso e Scartato',
    risolti: 'Ticket in stato Risolto: una replica di chi ha segnalato li riporta in coda',
    chiusi: 'Ticket in stato Chiuso: definitivi, non si riaprono',
    scartati: 'Ticket scartati, con il motivo: duplicato, spam o non pertinente',
};
/** Etichetta di una vista dell'ambito. */
function ticketListViewLabel(scope, view) {
    return scope === 'coda' ? exports.QUEUE_VIEW_LABELS[view] : exports.ARCHIVE_VIEW_LABELS[view];
}
/** Descrizione di una vista dell'ambito. */
function ticketListViewDescription(scope, view) {
    return scope === 'coda' ? exports.QUEUE_VIEW_DESCRIPTIONS[view] : exports.ARCHIVE_VIEW_DESCRIPTIONS[view];
}
/**
 * Ordinamenti della coda (story #47): `apertura` = dal più recente (default); `priorita` = Urgente →
 * Alta → Media → Bassa, poi i «Da triare», a parità dal più vecchio (chi aspetta da più tempo viene
 * prima). A parità di tutto decide il codice, unico: l'ordine è totale e le pagine sono stabili.
 * Nessun ordinamento per prodotto (DEC-003).
 */
exports.QUEUE_SORTS = ['apertura', 'priorita'];
exports.QUEUE_SORT_LABELS = {
    apertura: 'Data di apertura',
    priorita: 'Priorità',
};
/** Che cosa fa ciascun ordinamento, sotto l'etichetta nel menu. */
exports.QUEUE_SORT_DESCRIPTIONS = {
    apertura: 'Dal più recente',
    priorita: 'Da Urgente a Bassa, poi Da triare; a parità dal più vecchio',
};
/** Valore del filtro priorità per i ticket senza priorità. */
exports.UNTRIAGED_PRIORITY = 'da_triare';
/** Valore del filtro responsabile per i ticket senza responsabile. */
exports.NO_ASSIGNEE = 'nessuno';
/**
 * «Risposta ricevuta» (#122): un ticket aperto in cui l'ultimo messaggio verso l'esterno è una replica
 * del segnalante. Si deriva dal thread, senza tracciare chi ha letto cosa: le note interne non contano
 * e aprire il ticket non basta. Cessa quando un operatore risponde (anche con «Invia e chiudi») o quando
 * il ticket cambia stato a mano. Valori del filtro `reply`: oggi uno solo, `ricevuta`.
 */
exports.REPLY_RECEIVED = 'ricevuta';
exports.QUEUE_REPLY_FILTERS = [exports.REPLY_RECEIVED];
/** Etichetta della riga e del filtro per i ticket con la risposta del segnalante (#122). */
exports.REPLY_RECEIVED_LABEL = 'Risposta ricevuta';
exports.QUEUE_PAGE_SIZE_DEFAULT = 50;
exports.QUEUE_PAGE_SIZE_MAX = 100;
/** Lunghezza massima del testo cercato. */
exports.QUEUE_SEARCH_MAX_LENGTH = 200;
/** Parole considerate nella ricerca: oltre, le successive sono ignorate. */
exports.QUEUE_SEARCH_MAX_TERMS = 6;
exports.QUEUE_PRIORITY_FILTERS = [exports.UNTRIAGED_PRIORITY, ...ticket_priority_js_1.TICKET_PRIORITIES];
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const positiveInt = (label, max) => {
    const base = zod_1.z.coerce
        .number({ error: `${label}: deve essere un numero` })
        .int({ error: `${label}: deve essere un intero` })
        .min(1, { error: `${label}: almeno 1` });
    return max === undefined ? base : base.max(max, { error: `${label}: al massimo ${max}` });
};
/**
 * Query string di `GET /tickets`. L'ambito (`scope`, default la coda) sceglie quali stati entrano;
 * i filtri si combinano in AND; la vista, una di quelle dell'ambito, si aggiunge ai filtri;
 * l'ordinamento vale su tutto. Parametri sconosciuti sono rifiutati (400): in particolare non
 * esiste un filtro per prodotto.
 */
exports.ticketQueueQuerySchema = zod_1.z
    .strictObject({
    scope: zod_1.z
        .enum(exports.TICKET_LIST_SCOPES, { error: `Ambito non valido: ${exports.TICKET_LIST_SCOPES.join(' o ')}` })
        .default('coda'),
    view: zod_1.z.enum(exports.TICKET_LIST_VIEWS, { error: 'Vista non valida' }).default('tutti'),
    sort: zod_1.z.enum(exports.QUEUE_SORTS, { error: `Ordinamento non valido: ${exports.QUEUE_SORTS.join(' o ')}` }).default('apertura'),
    committente: zod_1.z
        .string({ error: 'Committente non valido' })
        .trim()
        .min(1, { error: 'Committente non valido' })
        .max(120, { error: 'Committente troppo lungo' })
        .optional(),
    priority: zod_1.z.enum(exports.QUEUE_PRIORITY_FILTERS, { error: 'Priorità non valida' }).optional(),
    /** `ricevuta` = solo i ticket con «Risposta ricevuta» (#122). */
    reply: zod_1.z.enum(exports.QUEUE_REPLY_FILTERS, { error: 'Filtro risposta non valido' }).optional(),
    state: zod_1.z.enum(ticket_state_js_1.TICKET_STATES, { error: 'Stato non valido' }).optional(),
    /** `nessuno` oppure l'id di un membro del team. */
    assignee: zod_1.z
        .string()
        .refine((value) => value === exports.NO_ASSIGNEE || UUID_PATTERN.test(value), {
        error: 'Responsabile non valido: «nessuno» o un id del team',
    })
        .optional(),
    q: zod_1.z
        .string({ error: 'Ricerca non valida' })
        .trim()
        .max(exports.QUEUE_SEARCH_MAX_LENGTH, { error: `Ricerca troppo lunga (massimo ${exports.QUEUE_SEARCH_MAX_LENGTH} caratteri)` })
        .optional()
        .transform((value) => (value ? value : undefined)),
    page: positiveInt('Pagina').default(1),
    pageSize: positiveInt('Dimensione della pagina', exports.QUEUE_PAGE_SIZE_MAX).default(exports.QUEUE_PAGE_SIZE_DEFAULT),
}, {
    error: (issue) => issue.code === 'unrecognized_keys' ? `Parametri non ammessi: ${issue.keys.join(', ')}` : undefined,
})
    .superRefine((query, context) => {
    if (isScopeView(query.scope, query.view))
        return;
    context.addIssue({
        code: 'custom',
        path: ['view'],
        message: `Vista non valida per ${query.scope === 'coda' ? 'la coda' : "l'archivio"}: ${exports.TICKET_LIST_SCOPE_VIEWS[query.scope].join(', ')}`,
    });
});
/** Parole della ricerca: separate da spazi, al più `QUEUE_SEARCH_MAX_TERMS`, senza duplicati. */
function searchTerms(q) {
    if (!q)
        return [];
    const terms = q.split(/\s+/).filter((term) => term.length > 0);
    return [...new Set(terms)].slice(0, exports.QUEUE_SEARCH_MAX_TERMS);
}
/** Ancora di un messaggio del thread (risposta, nota, messaggio dell'utente): `m-<id>` (#70). */
function threadMessageAnchor(id) {
    return `m-${id}`;
}
/** Ancora di un evento del thread: `e-<id>` (#70). */
function threadEventAnchor(id) {
    return `e-${id}`;
}
/**
 * Ancora di una voce del thread (#70): `id` DOM della voce e frammento del link delle notifiche
 * (`/ticket/{codice}#m-<id>`), così il link porta alla voce che ha generato la notifica. La
 * segnalazione iniziale è una sola per ticket: `segnalazione`.
 */
function threadEntryAnchor(entry) {
    switch (entry.kind) {
        case 'segnalazione':
            return 'segnalazione';
        case 'evento':
            return threadEventAnchor(entry.id);
        default:
            return threadMessageAnchor(entry.id);
    }
}
/** Codici di errore della coda, nel campo `code` del corpo di errore dell'API. */
exports.TICKET_QUEUE_ERROR_CODES = {
    /** Nessun ticket con quel codice. */
    notFound: 'tickets.not_found',
};
/** Lunghezza massima del titolo derivato. */
exports.TICKET_TITLE_MAX_LENGTH = 120;
/**
 * Titolo di un ticket: il contratto con i prodotti non ha un titolo distinto, quindi è la prima
 * riga non vuota della descrizione, con gli spazi compattati e troncata a parola intera oltre
 * `TICKET_TITLE_MAX_LENGTH` caratteri (con «…»).
 */
function ticketTitle(description) {
    const firstLine = description
        .split(/\r?\n/)
        .map((line) => line.replace(/\s+/g, ' ').trim())
        .find((line) => line.length > 0) ?? '';
    if (firstLine.length <= exports.TICKET_TITLE_MAX_LENGTH)
        return firstLine;
    const cut = firstLine.slice(0, exports.TICKET_TITLE_MAX_LENGTH - 1);
    const lastSpace = cut.lastIndexOf(' ');
    const head = lastSpace > exports.TICKET_TITLE_MAX_LENGTH / 2 ? cut.slice(0, lastSpace) : cut;
    return `${head.trimEnd()}…`;
}
//# sourceMappingURL=ticket-queue.js.map